"use client";

import { c as _c } from "react/compiler-runtime";
import type * as React from "react";
import { Arbitrary } from "..";
import { useContext } from "../context";
type Props = Partial<React.ComponentPropsWithoutRef<typeof Arbitrary>>;
export default function Sample(props) {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Component />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <Arbitrary {...props}>{t0}</Arbitrary>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}
function Component() {
  const $ = _c(3);
  const {
    seed
  } = useContext();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      padding: 40,
      display: "grid",
      placeItems: "center"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== seed) {
    t1 = <div style={t0}>{seed}</div>;
    $[1] = seed;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}